

<script>
    import { nav,user } from "./stores.js";
  import Messages from "./Messages.svelte";
  import Settings from "./Settings.svelte";
  import Nav from "./ui/Nav.svelte";
  import Page from "./ui/Page.svelte";
  import Footer from "./Footer.svelte";
  </script>

{#if $nav === 'settings'}

      
      <Page>
        <Nav>
          <div onclick="location.href='/'"
          style="cursor: pointer; ">
    
          Sign In
          </div></Nav>
        <Settings />
        <Footer />
      </Page>

{:else if $nav === 'messages'}
  <Page>
    <Nav
      showBack
      backText="Sign Out"
      onclick="$nav='settings';"

      
      on:back={() => {
        $nav = 'settings';
        setTimeout(() => {
          $nav = 'settings';
        }, 100);
      }}
    >
    <div onclick="location.href='/'"
      style="cursor: pointer; ">

      Ordinal Bears
      </div>
    </Nav>
    <Messages />
  </Page>
{/if}